import { constants } from 'app-constants'

let savedUser = localStorage.getItem('bqAgentUser')
if (!savedUser) savedUser = '{}'
const initialState = JSON.parse(savedUser)

export const authUser = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_USER:
      localStorage.setItem('bqAgentUser', JSON.stringify(action.payload))
      return action.payload
    case constants.UNSET_USER:
      localStorage.removeItem('bqAgentUser')
      return {}
    default:
      return state
  }
}
